import HyperLink, { StyledLink } from './HyperLink';
import {defaultStyle as HyperLinkDefaultStyling, invertedStyle as HyperLinkInvertedStyling} from './styling';

export { HyperLink, HyperLinkInvertedStyling, HyperLinkDefaultStyling, StyledLink };
